import { RootState } from 'src/store';
import { OCMTypes } from './ocm.types';

export const ocmSelector = (state: RootState): OCMTypes => state.ocm;
